import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CommonService } from '../common/common.service';


@Component({
  selector: 'app-module-container',
  templateUrl: './module-container.component.html',
  styleUrls: ['./module-container.component.scss']
})
export class ModuleContainerComponent implements OnInit {

  currentModule: string = '';
  moduleDetails: any;
  menuItems: any[] = [];
  showWelcomeMessage: boolean = false;
  showContactUs: boolean = false;

  constructor(private router: Router, private commonService: CommonService) {
  }

  ngOnInit(): void {
    // this.showWelcomeMessage = this.commonService.showWelcomeMessage();
    let url = window.location.pathname;
    // this.showContactUs = (url.includes('help') ? true : false);
    this.readModuleConfigurations();
    this.router.events.subscribe((routerData: any) => {
      let url = window.location.pathname;
      this.showContactUs = (url.includes('help') ? true : false);
      if (routerData['navigationTrigger']) {
        this.readModuleConfigurations();
      }
    });
  }

  readModuleConfigurations() {
    setTimeout(() => {
      let url = window.location.href;
      if (this.currentModule != url.split('/')[3]) {
        this.currentModule = url.split('/')[3];
        this.commonService.readConfigurationsData().subscribe(data => {
          this.moduleDetails = data['modules'].find((module: any) => module?.identifier === this.currentModule);
        });
        this.commonService.readModuleConfigurationsData(this.currentModule).subscribe((moduleData: any) => {
          this.menuItems = moduleData['header'];
          const regionName = sessionStorage.getItem('region');
          const op_api_url = moduleData['op_api_url'] + regionName + '/';
          sessionStorage.setItem('op_url', op_api_url);

        });
      }
    }, 500);
  }
  reload() {
    window.location.reload();
  }

}
